import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useLocationQuery from '../../hooks/useQuery';
import {
  getDashboardOrders,
  getDashboardOrdersReset,
  getDashboardOrdersCountsPerPharmacy,
} from '../../redux/dashboard';
import DashboardTable from './components/Table';

const LiveDashboardPage = () => {
  const dispatch = useDispatch();
  const { query } = useLocationQuery();

  const {
    status = 'unassigned',
    limit = 100,
    search,
    ...otherQuery
  } = query;

  const handleFetch = () => {
    if (status !== 'unassigned') {
      const { type } = otherQuery;
      dispatch(getDashboardOrdersCountsPerPharmacy({ type, status, search, limit }));
    } else {
      const orderTypes = [];

      if (otherQuery.type) {
        orderTypes.push(otherQuery.type);
      }

      if (status === 'requested') {
        orderTypes.push('assigned');
      }

      dispatch(getDashboardOrdersReset());
      dispatch(
        getDashboardOrders({
          ...otherQuery,
          search,
          status,
          limit,
          ...(orderTypes.length > 0 && { type: orderTypes }),
        })
      );
    }
  };

  useEffect(() => {
    handleFetch();
  // eslint-disable-next-line
  }, [otherQuery, status, limit]);

  return <DashboardTable handleFetch={handleFetch} />;
};

export default LiveDashboardPage;
